<template>
	<v-dialog
			:value="isPlanerWorkOrder"
			persistent
			width="740"
	>
				<div class="planerWorkOrderPopup">
					<div class="planerWorkOrderPopup_title">
						<span class="planerWorkOrderPopup_title-indicator">{{ workOrderId ? 'Edit' : 'Add' }} work order</span>
						<button type="button" @click="onClose">
							<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
						</button>
					</div>
					<div class="groupFieldWrapper fl-end" :class="{'disabled': !permissions[9]}">
						<div class="groupField_wrap">
							<div :style="'background:' + getIndicatorColor" v-if="status_id" class="indicator"></div>
							<field
									:class-error="getError('status_id')"
									margin="0"
									width="260px"
									label="Status"
									placeholder="Select status"
									@updateSelect="onAutocomplete($event, 'status_id')"
									:autocompleteValue="status_id"
									:items="getWorkOrderStatusList"
									:isClearable="false"
									is-select
									:is-required="isLightWorkOrder"
							></field>
						</div>
					</div>
					<div class="groupFieldWrapper" :class="{'disabled': !permissions[9]}">
						<div class="groupField_wrap">
							<field
									v-if="isLightWorkOrder"
									:class-error="getError('client_id')"
									margin="0 10px 0 0"
									width="213px"
									label="Client"
									placeholder="Select client"
									@updateAutocomplete="onAutocomplete($event, 'client_id')"
									@updateSearchText="onSearchText"
									:autocompleteValue="client_id"
									:items="customers"
									:isClearable="false"
									is-autocomplete
									:is-btn-autocomplete="!isNewWorkOrders"
									:is-required="isLightWorkOrder"
							></field>
							<field
									v-else
									margin="0 10px 0 0"
									width="213px"
									label="customer"
									placeholder="Select customer"
									@updateAutocomplete="onAutocomplete($event, 'customer_id')"
									:autocompleteValue="customer_id"
									:items="customers"
									:isClearable="false"
									is-autocomplete
									:is-disabled="!isLightWorkOrder"
							></field>
							<field
									:class-error="getError('unit_type_id')"
									margin="0 10px 0 0"
									width="213px"
									label="Unit type"
									placeholder="Select unit type"
									@updateSelect="onAutocomplete($event, 'unit_type_id')"
									:autocompleteValue="unit_type_id"
									:items="unitTypes"
									:isClearable="false"
									is-select
									:is-disabled="!isLightWorkOrder"
									:is-required="isLightWorkOrder"
							></field>
							<field
									v-if="isLightWorkOrder || isNewWorkOrders"
									:class-error="getError('unit')"
									margin="0"
									width="213px"
									label="Unit#"
									placeholder="Enter unit#"
									:setInputValue="unit"
									@updateInput="onInput($event, 'unit')"
									:is-disabled="!isLightWorkOrder"
									:is-required="isLightWorkOrder"
							></field>
							<field
									v-else
									:class-error="getError('unit_id')"
									margin="0"
									width="213px"
									label="Unit#"
									placeholder="Select unit"
									@updateAutocomplete="onAutocomplete($event, 'unit_id')"
									:autocompleteValue="unit_id"
									:items="unitList"
									:isClearable="false"
									is-autocomplete
									:is-required="isLightWorkOrder"
									:is-disabled="!isLightWorkOrder"
							></field>
						</div>
					</div>
					<split-repairs
							:workOrderId="!!workOrderId"
							:boxes="boxes"
							:isNewWorkOrders="isNewWorkOrders"
							:times="times"
							:vl="$v"
							:isLightWorkOrder="isLightWorkOrder"
							:isDirty="isDirty"
							:permissions="permissions"
							:isDelItem="isDelItem"
							@updateSplitRepairs="onSplitRepairs"
					></split-repairs>
					<repairs-table
							:filter="filter"
							:list-items="description"
							:createBy="create_by"
							@updateDescriptionList="onDescriptionList"
							@updateRepair="onRepair"
							@updateDeleteItem="onDeleteItem"
							:permissions="permissions"
							:isDelItem="isDelItem"
					></repairs-table>
					<button-groups
							:preloader="workOrdersPreloader"
							@updateBtnClose="onClose"
							@updateDelete="onDelete"
							@updateSave="onSave"
							apply-text="SUBMIT"
							:is-btn-delete="isDelItem"
							:is-btn-safe="!permissions[9]"
					></button-groups>
				</div>
	</v-dialog>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import SplitRepairs from "@/components/Fleet/WorkOrdersStatistics/Planer/SplitRepairs/SplitRepairs";
import RepairsTable from "@/components/Fleet/WorkOrdersStatistics/Planer/RepairsTable/RepairsTable";
// constants
import { STATUS_COLOR } from "@/constants/constants";
// validate
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import moment from "moment";
import getFormattedDate from "@/helper/getFormattedDate";

export default {
	name: "PlanerWorkOrder",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups,
		SplitRepairs,
		RepairsTable
	},
	props: {
		workOrderId: [ Number, String ],
		isNewWorkOrders: Boolean,
		isLightWorkOrder: Boolean,
		permissions: Object
	},
	computed: {
		...mapGetters([ 'planerWorkOrder', 'workOrdersPreloader' ]),
		getWorkOrderStatusList() {
			if (!this.flit_manager && !this.shop_manager) return this.workOrderStatus;
			if (this.flit_manager && this.defaultStatus === 3) {
				this.workOrderStatus.forEach(item => item.disabled = !(item.id === 3 || item.id === 9 || item.id === 11));
			} else if (this.shop_manager) {
				this.workOrderStatus.forEach(item => item.disabled = item.id === 9);
			} else {
				this.workOrderStatus.forEach(item => item.disabled = item.id !== 11);
			}

			return this.workOrderStatus;
		},
		getIndicatorColor() {
			const id = this.status_id?.id ?? this.status_id;
			return STATUS_COLOR[id];
		},
		isDelItem() {
			if (this.permissions[9]) {
				if (this.permissions[11]) {
					return !!this.workOrderId;
				}
			}

			return false;
		}
	},
	data: () => ({
		isPlanerWorkOrder: true,
		workOrderStatus: null,
		unitTypes: null,
		customers: null,
		filter: null,
		description: [],
		boxes: null,
		create_by: '',
		status_id: 10,
		customer_id: null,
		client_id: null,
		unit: null,
		unit_id: null,
		unit_type_id: null,
		unitList: [],
		isDirty: false,
		trailerList: [],
		truckList: [],
		flit_manager: false,
		shop_manager: false,
		defaultStatus: 10,
		times: [ {
			box_id: null,
			start_repair: null,
			end_repair: null
		} ],
	}),
	validations() {
		return this.getPerm();
	},
	methods: {
		...mapActions([
			'getPlanerWorkOrder',
			'setAlert',
			'onPlaner',
			'onWorkOrdersPreloader',
			'getWorkOrdersDelete',
			'onWorkOrdersDelete',
			'getLightOrder',
			'onLightOrderSave',
			'onCreateClient',
			'getLightWorkOrder',
			'onLightOrderEdit'
		]),
		getError(key) {
			if (this.isLightWorkOrder) {
				return this.$v[key]?.$error;
			}
			return false;
		},
		getPerm() {
			if (this.isLightWorkOrder) {
				return {
					client_id: { required },
					status_id: { required },
					unit_type_id: { required },
					unit: { required },
					times: {
						$each: {
							box_id: { required },
							start_repair: { required },
							end_repair: { required },
						}
					}
				};
			}

			return {
				times: {
					$each: {
						box_id: this.isDirty ? { required } : {},
						start_repair: this.isDirty ? { required } : {},
						end_repair: this.isDirty ? { required } : {}
					}
				}
			};
		},
		onDeleteItem(idx) {
			this.description.splice(idx, 1);
		},
		onRepair({ value, idx }) {
			this.description[idx]['msg'] = value;
		},
		onDescriptionList(item) {
			this.description.push(item);
		},
		onSplitRepairs({ value, idx, key }) {
			this.times[idx][key] = value?.id ?? value;
			this.isDirty = true;
		},
		onClose() {
			this.$emit('updateClose');
		},
		onDelete() {
			this.$emit('updateDelete', this.workOrderId);
		},
		onAutocomplete({ value }, key) {
			if (key === 'unit_type_id') {
				if (value.id === 1) {
					this.unitList = this.truckList;
				} else {
					this.unitList = this.trailerList;
				}

				this.unit_id = null;
			}

			this[key] = value?.id ?? null;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		async onSearchText(name) {
			this.customers = await this.onCreateClient({ name });
		},
		getValidateDate(times) {
			let validTime = true;
			let validDifferenceTime = true;
			const { start_repair, end_repair } = times[0];

			if (start_repair && end_repair) {
				for (let i = 0; i < times.length; i++) {
					if (!validTime) break;
					validTime = moment(times[i]['start_repair']).isBefore(times[i]['end_repair']);
				}

				if (times.length > 1) {
					for (let i = 1; i < times.length; i++) {
						if (!validDifferenceTime) break;
						validDifferenceTime = moment(times[i - 1]['end_repair']).isBefore(times[i]['start_repair']);
					}
				}
			}

			return validTime && validDifferenceTime;
		},
		getEventsErrorTime(errorTime) {
			this.times = this.times.map(item => {
				item.isErrorTime = errorTime.some(body => body['box_id'] === item['box_id']);
				return item;
			});

			setTimeout(() => {
				this.times = this.times.map(item => {
					delete item.isErrorTime;
					return item;
				});
			}, 4000);
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				await this.onWorkOrdersPreloader(true);
				const {
					status_id,
					description,
					times,
					unit_id,
					client_id,
					customer_id,
					unit,
					unit_type_id
				} = this.$data;
				const descriptionFormatted = description.map(item => {
					const { id, msg } = item;
					const value = { msg };
					if (id) value.id = id;

					return value;
				});

				const formattedTimes = times.map((item) => {
					const { start_repair, end_repair } = item;

					item['start_repair'] = getFormattedDate(start_repair);
					item['end_repair'] = getFormattedDate(end_repair);
					return item;
				});

				const isTime = formattedTimes.some(item => (item.box_id));

				let values = {
					status_id,
					description: descriptionFormatted
				};

				if (this.workOrderId) values.id = this.workOrderId;
				if (this.isLightWorkOrder) {
					values = { client_id, status_id, type_id: unit_type_id, unit, ...values };
				} else {
					values = { customer_id, unit_id, status_id, type_id: unit_type_id, unit, ...values };
				}

				if (isTime) values.times = formattedTimes;
				const isValidTimes = this.getValidateDate(formattedTimes);

				if (isValidTimes) {
					let requestKey = 'onLightOrderSave';

					if (this.workOrderId) {
						requestKey = this.isNewWorkOrders ? 'onPlaner' : 'onLightOrderEdit';
					}
					const { status, errorTime } = await this[requestKey](values);

					if (errorTime) {
						this.getEventsErrorTime(errorTime);
						this.setAlert({ type: "error", message: "The time of an order must not overlap with the time of another order." });
						await this.onWorkOrdersPreloader(false);
					} else if (status) {
						await this.onWorkOrdersDelete();
						this.getWorkOrdersDelete({ isDelete: true });
						await this.onWorkOrdersPreloader(false);
						this.setAlert({ type: "success", message: "Saving Successfully" });
						this.$emit('updateSuccess');
						this.onClose();
					} else {
						this.setAlert({ type: "error", message: "Saving error" });
						await this.onWorkOrdersPreloader(false);
					}
				} else {
					this.setAlert({ type: "error", message: "Start of work, should be less than the end of work" });
					await this.onWorkOrdersPreloader(false);
				}
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
				await this.onWorkOrdersPreloader(false);
			}
		}
	},
	async mounted() {
		this.$emit('updatePreload', true);
		if (this.workOrderId) {
			const requestKey = this.isNewWorkOrders ? 'getPlanerWorkOrder' : 'getLightWorkOrder';
			await this[requestKey](this.workOrderId);
		} else {
			await this.getLightOrder();
		}

		if (this.planerWorkOrder) {
			const {
				box,
				create_by,
				description,
				workOrder,
				workOrderStatus,
				trailer,
				truck,
				customers,
				unitType,
				times,
				filter,
				flit_manager,
				shop_manager
			} = this.planerWorkOrder;

			this.boxes = box;
			this.create_by = create_by;
			this.description = description || [];
			this.filter = filter;
			this.times = times && times.length ? times : [ { box_id: null, start_repair: null, end_repair: null } ];
			this.trailerList = trailer;
			this.truckList = truck;

			this.workOrderStatus = workOrderStatus;
			this.customers = customers;
			this.unitTypes = unitType;
			this.flit_manager = flit_manager;
			this.shop_manager = shop_manager;

			if (workOrder) {
				if (workOrder['unit_type_id'] === 1) {
					this.unitList = this.truckList;

				} else {
					this.unitList = this.trailerList;
				}

				for (const workOrderKey in workOrder) {
					this[workOrderKey] = workOrderKey.includes('option') || workOrderKey === "arrived" ? Boolean(workOrder[workOrderKey]) : workOrder[workOrderKey];
				}

				this.defaultStatus = this.status_id;
			}
		}

		await this.onWorkOrdersPreloader(false);
		this.$emit('updatePreload', false);
	}
};
</script>

<style scoped lang="scss">
	@import "planerWorkOrder";
</style>
